import { styled, Tab, Typography } from "@mui/material";
import { colors } from "../../../utils";

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  "@media (max-width: 600px)": {
    gap: "16px",
    padding: "0 8px",
  },
}));

export const TabContainer = styled("div")(() => ({
  display: "flex",
  gap: "10px",
  borderRadius: "100px",
  width: "340px",
  alignSelf: "center",
  backgroundColor: "#F6F7F9",
  "@media (max-width: 600px)": {
    width: "100%",
    gap: "4px",
    padding: "0 2px",
    minWidth: 0,
    overflowX: "auto",
    whiteSpace: "nowrap",
    justifyContent: "center",
    WebkitOverflowScrolling: "touch",
  },
}));

export const StyledTab = styled(Tab)(() => ({
  textTransform: "none",
  width: "170px",
  backgroundColor: "#F6F7F9",
  padding: "10px 8px",
  color: "#9A999A",
  fontSize: "14px",
  lineHeight: "20px",
  fontFamily: '"DM Sans", sans-serif',
  borderRadius: "100px",
  minWidth: "110px",
  flexShrink: 0,
  "&.Mui-selected": {
    backgroundColor: "#9B5AF8",
    color: "#FFFFFF",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#9B5AF8",
  },
  "@media (max-width: 600px)": {
    width: "auto",
    flex: 1,
    minWidth: "110px",
    fontSize: "13px",
    padding: "12px 4px",
    flexShrink: 0,
  },
}));

export const AnnualTabContainer = styled("div")(() => ({
  display: "flex",
  gap: "6px",
  alignItems: "center",
  minWidth: 0,
  "@media (max-width: 600px)": {
    gap: "4px",
  },
}));

export const SavingsText = styled("div")(() => ({
  border: "2px solid #F5CC3B",
  backgroundColor: "#F5CC3B",
  paddingLeft: "4px",
  paddingRight: "4px",
  borderRadius: "4px",
  fontWeight: 600,
  fontFamily: '"DM Sans", sans-serif',
  fontSize: "12px",
  color: colors.primary,
}));

export const PricingContainer = styled("div")(() => ({
  display: "flex",
  flex: 1,
  gap: "8px",
  "@media (max-width: 600px)": {
    flexDirection: "column",
    gap: "12px",
    width: "100%",
  },
}));

export const LoadingContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
}));

export const PricingItem = styled("div")(
  ({ isBestDeal, isComparisonOpen, isActive }) => ({
    display: "flex",
    flex: 0.25,
    height: isComparisonOpen ? "283px" : "465px",
    flexDirection: "column",
    gap: "16px",
    padding: "16px 0px 16px 0px",
    borderRadius: "8px",
    backgroundColor: isBestDeal
      ? "#F5CC3B"
      : isActive
      ? "#9B5AF8B5"
      : "#FFFFFF",
    boxShadow: "0px 0px 5.9px 0px #00000040",
  })
);

export const BestDealBanner = styled("div")(() => ({
  background: "#F5CC3B",
  color: "#123051",
  borderRadius: "16px",
  paddingLeft: "8px",
  paddingRight: "8px",
  fontWeight: 700,
  fontSize: "14px",
  fontFamily: '"DM Sans", sans-serif',
}));

export const InformationContainer = styled("div")(({ setSpacing }) => ({
  display: "flex",
  flexDirection: "column",
  gap: setSpacing ? "8px" : "16px",
  padding: "0px 16px 0px 16px",
}));

export const Description = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  height: "110px",
}));

export const Price = styled("div")(() => ({
  display: "flex",
  gap: "8px",
  flexDirection: "column",
}));

export const AnnualPrice = styled("div")(() => ({
  display: "flex",
  gap: "4px",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  backgroundColor: "#F6F7F9",
}));

export const AnnualPriceValue = styled(Typography)(() => ({
  fontSize: "14px",
  color: "#123051",
  fontWeight: 500,
  fontFamily: '"DM Sans", sans-serif',
}));

export const ButtonContainer = styled("div")(() => ({
  border: "1px solid #9B5AF8",
  borderRadius: "4px",
  padding: "8px",
  backgroundColor: "#EFE9FE",
  fontSize: "14px",
  color: "#9B5AF8",
  fontWeight: 700,
  display: "flex",
  justifyContent: "center",
}));

export const DetailsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const ListItem = styled("div")(() => ({
  display: "flex",
  gap: "8px",
}));

export const LastItem = styled("div")(({ isComparison = false, isActive }) => ({
  display: "flex",
  height: isComparison ? "auto" : "100%",
  alignItems: "center",
  justifyContent: "flex-end",
  flexDirection: "column",
  gap: "16px",
  backgroundColor: isActive ? "#F8F6FF" : "transparent",
}));

export const StyledLine = styled("div")(({ customColor }) => ({
  border: `1px solid ${customColor || "#E1E1E1"}`,
  width: "100%",
}));

export const HeadingContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
}));

export const CancelButtonContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "end",
  height: "70px",
}));

export const SubscriptionContainer = styled("div")(() => ({
  display: "flex",
  flex: 0.25,
  flexDirection: "column",
  "@media (max-width: 600px)": {
    flex: 1,
    width: "100%",
  },
}));
